import * as angular from 'angular';

export class UserService {
    constructor() {
    }

    generateUsername(firstName, lastName) {
        if (firstName && lastName) {
            let username = firstName.substring(0, 1) + lastName;
            return username.toLowerCase();
        }
    }
}

angular
    .module('app')
    .service('UserService', UserService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/user.service.ts